export default __webpack_public_path__ + "maps-examples-user-location-annotation-960-fe47c4f144a13f98e916b8653466319a.webp";